import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import JobsContext from '../context/JobsContext';
import ListJobs from '../components/ListJobs';
import AdBanner from '../components/AdBanner';
import { useThemePalette } from '../theme';

export default function FavoritesScreen() {
  const { t } = useTranslation();
  const { data, keys, refreshing, handleClearFavorites } = useContext(JobsContext);
  const palette = useThemePalette();

  const favs = data.filter(({ id }) => keys.includes(id));

  const refresh = () => {};

  return (
    <View style={[styles.container, { backgroundColor: palette.canvas }]}>
      <ListJobs
        jobs={favs}
        refresh={refresh}
        refreshing={refreshing}
        clearFavorites={handleClearFavorites}
        title={t('tabs.favorites')}
        emptyMessage={keys.length === 0 ? t('favorites.empty') : undefined}
      />
      <AdBanner />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
});
